const educ1Overview = [
    {
        "country": "Switzerland",
        "rank": 1,
        "project": 100,
        "career": 95,
        "employ": 94,
        "edu": 72,
        "econ": 75,
        "liva": 75,
        "total": 85
    },
    {
        "country": "USA",
        "rank": 2,
        "project": 93,
        "career": 86,
        "employ": 94,
        "edu": 74,
        "econ": 74,
        "liva": 68,
        "total": 82
    },
    {
        "country": "Singapore",
        "rank": 3,
        "project": 100,
        "career": 66,
        "employ": 97,
        "edu": 55,
        "econ": 92,
        "liva": 65,
        "total": 79
    },
    {
        "country": "Australia",
        "rank": 4,
        "project": 66,
        "career": 79,
        "employ": 84,
        "edu": 73,
        "econ": 74,
        "liva": 74,
        "total": 75
    },
    {
        "country": "Canada",
        "rank": 5,
        "project": 67,
        "career": 79,
        "employ": 84,
        "edu": 71,
        "econ": 73,
        "liva": 72,
        "total": 74
    },
    {
        "country": "United Kingdom",
        "rank": 6,
        "project": 59,
        "career": 85,
        "employ": 72,
        "edu": 79,
        "econ": 75,
        "liva": 68,
        "total": 73
    },
    {
        "country": "Austria",
        "rank": 7,
        "project": 65,
        "career": 56,
        "employ": 69,
        "edu": 51,
        "econ": 75,
        "liva": 68,
        "total": 64
    },
    {
        "country": "Hong Kong (SAR China)",
        "rank": 7,
        "project": 76,
        "career": 70,
        "employ": 86,
        "edu": 49,
        "econ": 50,
        "liva": 51,
        "total": 64
    },
    {
        "country": "Spain",
        "rank": 8,
        "project": 47,
        "career": 60,
        "employ": 63,
        "edu": 53,
        "econ": 93,
        "liva": 60,
        "total": 63
    },
    {
        "country": "United Arab Emirates",
        "rank": 8,
        "project": 77,
        "career": 44,
        "employ": 83,
        "edu": 49,
        "econ": 67,
        "liva": 55,
        "total": 63
    },
    {
        "country": "Italy",
        "rank": 9,
        "project": 50,
        "career": 61,
        "employ": 58,
        "edu": 51,
        "econ": 93,
        "liva": 58,
        "total": 62
    },
    {
        "country": "New Zealand",
        "rank": 10,
        "project": 60,
        "career": 40,
        "employ": 56,
        "edu": 55,
        "econ": 75,
        "liva": 67,
        "total": 59
    },
    {
        "country": "Malta",
        "rank": 11,
        "project": 43,
        "career": 54,
        "employ": 68,
        "edu": 34,
        "econ": 75,
        "liva": 55,
        "total": 55
    },
    {
        "country": "Portugal",
        "rank": 12,
        "project": 46,
        "career": 42,
        "employ": 47,
        "edu": 43,
        "econ": 74,
        "liva": 61,
        "total": 52
    },
    {
        "country": "Greece",
        "rank": 13,
        "project": 40,
        "career": 37,
        "employ": 46,
        "edu": 43,
        "econ": 74,
        "liva": 52,
        "total": 49
    }
];

export {educ1Overview};